/* Private R2 uploads. No access keys, public file URLs or document bytes in browser storage. */
(function () {
  'use strict';
  var root = document.querySelector('[data-lux-documents-config]');
  if (!root) return;
  var config;
  try { config = JSON.parse(root.textContent); } catch (_) { return; }
  var form = document.getElementById('LuxApplicationForm');
  var records = new Map();
  var application = crypto.randomUUID();
  var queue = Promise.resolve();
  var busy = 0;
  var widget, tokenWaiter, widgetResolve, widgetReject;
  var widgetReady = new Promise(function (resolve, reject) { widgetResolve = resolve; widgetReject = reject; });
  // Handle a blocked verification script without an unhandled promise rejection.
  widgetReady.catch(function () {});
  var strings = config.strings;
  var base;
  try { base = new URL(config.endpoint); if (base.protocol !== 'https:') throw new Error(); }
  catch (_) { base = null; }
  var loadTimeout = setTimeout(function () { widgetReject(new Error('verification_unavailable')); }, 30000);
  window.luxDocumentsTurnstileReady = function () {
    try {
      widget = window.turnstile.render('[data-lux-documents-verification]', {
        sitekey: config.sitekey, action: 'lux_documents', execution: 'execute', appearance: 'interaction-only',
        callback: function (token) { if (tokenWaiter) { var current = tokenWaiter; tokenWaiter = null; current.resolve(token); } },
        'error-callback': function () { if (tokenWaiter) { var current = tokenWaiter; tokenWaiter = null; current.reject(new Error('verification_failed')); } },
        'expired-callback': function () { if (tokenWaiter) { var current = tokenWaiter; tokenWaiter = null; current.reject(new Error('verification_expired')); } },
      });
      clearTimeout(loadTimeout); widgetResolve();
    } catch (_) { clearTimeout(loadTimeout); widgetReject(new Error('verification_unavailable')); }
  };
  if (base && config.sitekey) {
    var script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=luxDocumentsTurnstileReady&render=explicit';
    script.async = true;
    script.onerror = function () { clearTimeout(loadTimeout); widgetReject(new Error('verification_unavailable')); };
    document.head.appendChild(script);
  } else { clearTimeout(loadTimeout); widgetReject(new Error('not_configured')); }
  async function freshToken() {
    await widgetReady;
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () { tokenWaiter = null; reject(new Error('verification_timeout')); }, 120000);
      tokenWaiter = {
        resolve: function (token) { clearTimeout(timer); resolve(token); },
        reject: function (error) { clearTimeout(timer); reject(error); },
      };
      window.turnstile.reset(widget); window.turnstile.execute(widget);
    });
  }
  function sendFile(file, slot, token, progress) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      var url = new URL('/upload', base); url.searchParams.set('application', application); url.searchParams.set('slot', slot);
      xhr.open('POST', url.href); xhr.timeout = 120000;
      xhr.setRequestHeader('Content-Type', 'application/octet-stream');
      xhr.setRequestHeader('X-Turnstile-Token', token);
      xhr.upload.onprogress = function (event) { if (event.lengthComputable) progress(Math.min(99, Math.round(event.loaded / event.total * 100))); };
      xhr.onload = function () {
        var body; try { body = JSON.parse(xhr.responseText); } catch (_) { body = {}; }
        if (xhr.status < 200 || xhr.status >= 300 || !body.id || !body.receipt || !body.staffUrl) return reject(new Error(body.error || 'upload_failed'));
        // The link is for the allowlisted staff origin, never an arbitrary server-provided URL.
        var link; try { link = new URL(body.staffUrl); } catch (_) { return reject(new Error('upload_failed')); }
        if (link.origin !== config.staffOrigin || link.pathname !== '/staff/application/' + application) return reject(new Error('upload_failed'));
        resolve(body);
      };
      xhr.onerror = xhr.ontimeout = xhr.onabort = function () { reject(new Error('upload_failed')); };
      xhr.send(file);
    });
  }
  function errorMessage(error) {
    if (error.message === 'file_too_large') return strings.tooLarge;
    if (error.message === 'unsupported_file') return strings.unsupported;
    return strings.failed;
  }
  document.querySelectorAll('[data-lux-r2-picker]').forEach(function (picker) {
    var card = picker.closest('.lux-apply__doc');
    var field = card.querySelector('[data-lux-doc]');
    var status = card.querySelector('[data-lux-doc-status]');
    var change = card.querySelector('[data-lux-doc-change]');
    var retry = picker.querySelector('[data-lux-r2-retry]');
    var inputs = picker.querySelectorAll('[data-lux-r2-file]');
    var slot = inputs[0].getAttribute('data-lux-r2-file');
    var selectedFile;
    function lock(value) { inputs.forEach(function (input) { input.disabled = value; }); retry.disabled = value; change.disabled = value; }
    function state(text, failed) {
      status.hidden = false; status.textContent = text;
      status.classList.toggle('lux-apply__doc-status--failed', !!failed);
      status.setAttribute('role', failed ? 'alert' : 'status');
    }
    function start(file) {
      if (!file) return;
      selectedFile = file; field.value = ''; records.delete(slot);
      card.classList.remove('lux-apply__doc--done'); retry.hidden = true; change.hidden = true;
      var warning = card.querySelector('[data-lux-doc-warn]'); if (warning) warning.hidden = true;
      if (file.size > 20971520) { state(strings.tooLarge, true); return; }
      if (!file.size || !/\.(jpe?g|png|webp|gif|avif|heic|heif|pdf)$/i.test(file.name)) { state(strings.unsupported, true); return; }
      lock(true); busy++; state(strings.uploading + ' · ' + file.name, false);
      queue = queue.catch(function () {}).then(async function () {
        try {
          file = await window.luxOptimiseDocument(file);
          var token = await freshToken();
          var result = await sendFile(file, slot, token, function (percent) { state(strings.uploading + ' ' + percent + '%', false); });
          records.set(slot, { id: result.id, receipt: result.receipt, slot: slot });
          field.value = result.staffUrl;
          state('✓ ' + strings.uploaded + ' · ' + file.name, false);
          card.classList.add('lux-apply__doc--done'); card.classList.remove('lux-apply__doc--missing');
          change.hidden = false;
          document.dispatchEvent(new CustomEvent('lux:document-uploaded', { detail: { key: field.getAttribute('data-lux-doc'), entry: { uuid: result.id, file: file, mimeType: file.type } } }));
          var missing = document.querySelector('.lux-apply__doc--missing');
          var error = document.querySelector('[data-lux-docs-error]'); if (!missing && error) error.hidden = true;
        } catch (error) { state(errorMessage(error), true); retry.hidden = false; }
        finally { busy--; lock(false); }
      });
    }
    inputs.forEach(function (input) { input.addEventListener('change', function () { var file = input.files[0]; input.value = ''; start(file); }); });
    retry.addEventListener('click', function () { start(selectedFile); });
    change.addEventListener('click', function () { inputs[0].click(); });
  });
  form.querySelectorAll('[data-lux-identity]').forEach(function (select) {
    function updateIdentity() {
      var buyer = select.dataset.luxIdentity === 'buyer';
      var front = form.querySelector('[data-lux-doc-card="' + (buyer ? 'up_id_front' : 'up_g_front') + '"]');
      var back = form.querySelector('[data-lux-doc-card="' + (buyer ? 'up_id_back' : 'up_g_back') + '"]');
      var yellow = select.value === 'yellow_slip';
      var label = front.querySelector('.lux-apply__doc-label');
      label.textContent = yellow ? config.yellowSlip : label.dataset.idLabel;
      front.querySelectorAll('[data-lux-r2-file]').forEach(function(input){input.setAttribute('aria-label', label.textContent);});
      back.hidden = yellow; back.querySelector('[data-lux-doc]').disabled = yellow;
      back.classList.remove('lux-apply__doc--missing');
    }
    select.addEventListener('change', updateIdentity); updateIdentity();
  });
  function applicationDetails() {
    var value = function(name) { var el = form.elements.namedItem('contact[' + name + ']'); return el && !el.disabled ? el.value.trim() : ''; };
    var guarantor = form.querySelector('[data-lux-warrantor]');
    return {
      locale: config.locale,
      consent: !!form.querySelector('[name="contact[Συγκατάθεση επεξεργασίας δεδομένων]"]').checked,
      buyer: {name:value('Ονοματεπώνυμο'),phone:value('Τηλέφωνο'),email:value('email'),address:value('Διεύθυνση κατοικίας'),postal:value('Ταχυδρομικός κώδικας'),city:value('Πόλη'),job:value('Επάγγελμα')},
      guarantor: guarantor.disabled ? null : {name:value('Εγγυητής'),phone:value('Τηλέφωνο εγγυητή'),address:value('Διεύθυνση εγγυητή'),postal:value('Ταχ. κώδικας εγγυητή'),city:value('Πόλη εγγυητή'),job:value('Επάγγελμα εγγυητή')},
      delivery: form.querySelector('[data-lux-delivery-toggle]').checked ? {address:value('Διεύθυνση παράδοσης'),postal:value('Τ.Κ. παράδοσης'),city:value('Πόλη παράδοσης')} : null,
      contactTime: value('Ώρα επικοινωνίας'), plan:value('Πλάνο')
    };
  }
  window.luxDocuments = {
    finalize: async function (reference) {
      if (busy) throw new Error(strings.wait);
      var documents = [];
      form.querySelectorAll('[data-lux-doc]').forEach(function (field) {
        var fieldset = field.closest('fieldset'); if (field.disabled || (fieldset && fieldset.disabled)) return;
        var slot = field.getAttribute('data-lux-doc').replace(/^lux-/, '');
        if (!field.value || !records.has(slot)) throw new Error(strings.failed);
        documents.push(records.get(slot));
      });
      var response = await fetch(new URL('/finalize', base), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ application: application, reference: reference, documents: documents,
          identityTypes: {buyer:form.querySelector('[data-lux-identity="buyer"]').value,guarantor:form.querySelector('[data-lux-warrantor]').disabled ? null : form.querySelector('[data-lux-identity="guarantor"]').value},
          submission: applicationDetails()
        }),
        signal: AbortSignal.timeout(60000),
      });
      if (!response.ok) throw new Error(strings.saveFailed);
      var result = await response.json();
      if (!result.ok || !result.submissionSaved || !/^LUX-A-\d{8}-\d{4}$/.test(result.reference || '')) throw new Error(strings.saveFailed);
      return result.reference;
    }
  };
})();
